import { Icon } from './Icon';

/** Птичка галочки-барьера: крупнее и толще, чем «принято», — она заполняет квадрат 20. */
export function TickIcon() {
  return (
    <Icon size={11} box={[13, 11]} strokeWidth={1.6}>
      <path d="M1 5 L4.4 8.6 L11.4 1.4" />
    </Icon>
  );
}
